import React, { useState } from 'react';
import Button from '@components-clean/core/button';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { useBoolean } from '@hooks/index';

const STEP_COUNT = 3;

const stepTitles: Record<number, string> = {
    1: 'Details',
    2: 'Configuration',
    3: 'Review',
};

const DraggableDialogSteppedPage = () => {
    const isOpen = useBoolean(false);
    const [currentStep, setCurrentStep] = useState(1);

    const handleOpen = () => {
        setCurrentStep(1);
        isOpen.setTrue();
    };

    const handleStepAction = (event: { action: string }) => {
        if (event.action === 'back') setCurrentStep((s) => Math.max(1, s - 1));
        if (event.action === 'next') setCurrentStep((s) => Math.min(STEP_COUNT, s + 1));
    };

    return (
        <>
            <Button onClick={handleOpen} primary data-testid="open-stepped-dialog-button">
                Open Stepped Dialog
            </Button>
            {isOpen.value && (
                <DraggableDialog
                    title="Stepped Dialog Example"
                    dataTestId="stepped-dialog-example"
                    stepCount={STEP_COUNT}
                    currentStep={currentStep}
                    currentStepTitle={stepTitles[currentStep]}
                    onStepAction={handleStepAction}
                    onClose={isOpen.setFalse}
                    onSubmit={() => setCurrentStep(STEP_COUNT + 1)}
                    primaryBtnLabel="Save"
                    secondaryBtnLabel="Cancel"
                    initialWidth={600}
                    initialHeight={380}
                >
                    {currentStep === 1 && (
                        <div className="k-px-4 k-py-2">
                            <p className="k-mb-2">
                                <strong>Step 1 — Details</strong>
                            </p>
                            <p>Enter the basic details for this record. Use the Next button to proceed.</p>
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div className="k-px-4 k-py-2">
                            <p className="k-mb-2">
                                <strong>Step 2 — Configuration</strong>
                            </p>
                            <p>Configure the settings. Use Back to return to Step 1 or Next to proceed.</p>
                        </div>
                    )}
                    {currentStep === 3 && (
                        <div className="k-px-4 k-py-2">
                            <p className="k-mb-2">
                                <strong>Step 3 — Review</strong>
                            </p>
                            <p>Review your selections. Click Save to confirm or Back to make changes.</p>
                        </div>
                    )}
                </DraggableDialog>
            )}
        </>
    );
};

export default DraggableDialogSteppedPage;
